import 'vuetify/dist/vuetify.min.css'
//import '@mdi/font/css/materialdesignicons.css'
import '@mdi/font/css/materialdesignicons.css'
import '@mdi/font/scss/materialdesignicons.scss'

import Vue from 'vue'
import Vuetify from 'vuetify'

import App from './App.vue'
import router from './router'
import store from './store/store'
import config from "./config";


Vue.config.productionTip = false;

Vue.use(Vuetify);

new Vue({
    router,
    store,
    vuetify: new Vuetify({
        theme: config.theme,
        defaultAssets: {
//            font: false,
            icons: false,
        },
    }),
    beforeCreate() {
        this.$store.dispatch('login/initializeStore');
    },
    render: function (h) {
        return h(App)
    }
}).$mount('#app');
